import React from "react";
import { Button } from "@/components/ui/button";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    if (import.meta.env.DEV) {
      console.error("Route render failed", error);
    }
  }

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="min-h-[60vh] grid place-items-center p-6 text-center">
        <div className="max-w-md rounded-3xl border border-border bg-card/90 p-8 shadow-xl">
          <h1 className="text-2xl font-heading font-bold">Something went wrong</h1>
          <p className="mt-2 text-sm text-muted-foreground">This page failed to load safely. Reloading usually fixes it.</p>
          <Button className="mt-6" onClick={() => window.location.reload()}>Reload page</Button>
        </div>
      </div>
    );
  }
}